export default [
  'FLOWVIZ',
  'FORECAST',
  'TEMPERATURE_FORECAST',
  'PRESSURE_FORECAST',
  'MARINE_FORECAST',
  'SURFACE_CURRENTS',
  'WIND',
  'WIND_GUST',
  'RADAR',
  'LIVE_WIND',
  'SATELLITE',
  'SST',
  'ONSITE_REPORTS',
  'SATELLITE_RADAR',
  'NAUTICAL_CHARTS_WIND',
  'NOWCAST',
  'FAVORITE_SPOTS'
]

// Needed when WIND_RADAR_SATELLITE map type launches: 'WIND_RADAR_SATELLITE'
